import { defineMessages } from 'react-intl';

export default defineMessages({
  filterBy: `Filter By`,
  searchByAssetName: `Search By Asset Name`,
  all: 'All',
  stableCoins: 'Stable Coins',
  ownedAssets: 'Owned Assets',
});
